import { ReportGroupingMode } from 'src/enums'

export const toReportGroupingMode = (groupByPosition: boolean): ReportGroupingMode =>
  groupByPosition ? ReportGroupingMode.ByPositionAndProduct : ReportGroupingMode.ByProduct
